<div class="chart-container progress-chart progress-cal">
    <div [ngClass]="{'selected-bar': isSelected}">
        <apx-chart 
            [chart]="chartData.chart" 
            [plotOptions]="chartData.plotOptions" 
            [colors]="chartData.colors" 
            [stroke]="chartData.stroke" 
            [fill]="chartData.fill" 
            [series]="chartData.series" 
            [title]="chartData.title" 
            [subtitle]="chartData.subtitle" 
            [tooltip]="chartData.tooltip" 
            [xaxis]="chartData.xaxis" 
            [yaxis]="chartData.yaxis" 
            [responsive]="chartData.responsive">
        </apx-chart>
    </div>
</div>
